export default "/dist/fonts/Roboto-Italic.ttf";